import React from 'react';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Viewer } from './Viewer/Viewer';
import Navigation from './Navigation/Navigation';
import { isMobile } from 'react-device-detect';
import NoFileInfo from './NoFileInfo/NoFileInfo';


export default class App extends React.Component<any, any> {
  scaleStep: number = 0.1;

  constructor(props: any) {
    super(props);
    this.getFileFromRequest();
    this.state = {
      scale: 1,
      file: this.getFileFromRequest()
    }
  }

  getFileFromRequest() {
    var url = new URL(window.location.href);
    var v = url.searchParams.get("v");
    return v;
  }

  onPlus = () => {
    this.setState({ scale: this.state.scale + this.scaleStep });
  }
  onMinus = () => {
    this.setState({ scale: this.state.scale - this.scaleStep });
  }


  render() {
    return (
      <>
        {this.state.file != null && <>
          <Viewer file={this.state.file} scale={this.state.scale} />
          {!isMobile && <Navigation onPlus={() => this.onPlus()} onMinus={() => this.onMinus()} />}
        </>}
        {this.state.file == null && <>
          <NoFileInfo />
        </>}
      </>
    );
  }
}